import React from "react";
import { Link } from "react-router-dom";

const BackButton = props => {
    return <Link id="floating-button" className="back-button" to="/">Back</Link>
}

export default BackButton;